<template>
  <el-dialog
    title="忘记密码"
    :visible.sync="disalbog"
    append-to-body
    width="460px" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form ref="login" :model="form" size="medium" label-position="left">
        <el-form-item>
          <el-input
              v-model="form.phone"
              type="text"
              placeholder="手机号"
              prefix-icon="el-icon-user"
              autocomplete="off"
              clearable/>
        </el-form-item>
        <el-form-item>
          <el-input
              v-model="form.password"
              type="text"
              placeholder="密码"
              prefix-icon="el-icon-lock"
              autocomplete="off"
              clearable
              show-password/>
        </el-form-item>
        <el-form-item>
          <el-input
              v-model="form.newPassword"
              type="text"
              placeholder="确认密码"
              prefix-icon="el-icon-lock"
              autocomplete="off"
              clearable
              show-password/>
        </el-form-item>
        <el-form-item>
          <div style="position: relative;">
            <el-input
              v-model="form.verify"
              type="text"
              placeholder="请输入验证码"
              prefix-icon="el-icon-user"
              autocomplete="off"
              clearable/>
              <div style="width: 100%;display: flex;">
                <el-button @click.stop="sendSMS" type="text" style="margin-left: auto;" v-if="countdown==0">
                  <span style="color: rgb(42, 163, 139);">
                    获取验证码
                  </span>
                </el-button>
                <el-button  type="text" style="margin-left: auto;" disabled v-if="countdown>0">
                  <span style="color: #aaa;">
                    {{countdown}}s后重新发送
                  </span>
                </el-button>
              </div>
          </div>
        </el-form-item>
        <el-button
            :loading="loading"
            size="small"
            type="primary"
            style="width:100%;"
            @click.native.prevent="handleLogin">
          <span v-if="!loading">立即重置</span>
          <span v-else>重 置 中...</span>
        </el-button>
        <div style="width: 100%;display: flex;">
          <el-button type="text" size="small" style="margin-left: auto;">
            <span style="color: #2AA38B;">已有账号，立即登录</span>
          </el-button>
        </div>
      </el-form>
  </el-dialog>
</template>

<script>
  import { sendSms,updatePassword } from "@/api/gw/login.js"
  export default {
    data(){
      return{
        disalbog:false,
        form:{
          phone:"",//手机号
          verify_id:"",//验证码ID
          verify:"",//验证码
          password:"",//新密码
          newPassword:"",//新密码
        },
        countdown:0,
        timer:null,
        loading:false,

      }
    },
    watch:{
      disablog(e){
        if(e==false){
          if(this.timer){
            clearInterval(this.timer);
          }
        }
      },
    },
    methods:{
       //获取验证码
      sendSMS(){
         if(!this.form.phone){
           this.$message.error("请输入手机号");
           return;
         }
         const loading = this.$loading({
               lock: true,
               text: '发送中',
               spinner: 'el-icon-loading',
               background: 'rgba(0, 0, 0, 0.7)'
             });
          sendSms({
            mobile:this.form.phone
          }).then(res=>{
            this.form.verify_id = res.key
            this.countdown = 60
            this.timer = setInterval(()=>{
              if(this.countdown<=0){
                this.countdown = 0
                clearInterval(this.timer)
              }else{
                this.countdown--;
              }
            },1000)
          }).finally(()=>{
            loading.close();
          })
      },
       handleLogin(){
         if(!this.form.phone){
           this.$message.error("请输入手机号");
           return;
         }
         if(!this.form.password || !this.form.newPassword){
           this.$message.error("请输入密码");
           return;
         }
         if(this.form.password!=this.form.newPassword){
           this.$message.error("两次密码不一致");
           return;
         }
         if(!this.form.verify){
           this.$message.error("请输入短信验证码");
           return;
         }
         this.loading = true
         const loading = this.$loading({
               lock: true,
               text: '重置中',
               spinner: 'el-icon-loading',
               background: 'rgba(0, 0, 0, 0.7)'
             });
          updatePassword({
            mobile:this.form.phone,
            phone:this.form.phone,
            verify_id:this.form.verify_id,
            verify:this.form.verify,
            password:this.form.password
          }).then(()=>{
            this.$message.success("重置成功")
            this.disalbog = false;
          }).finally(()=>{
            this.loading = false
            loading.close();
          })
       },
       show(){
         this.$nextTick(()=>{
           this.disalbog = true
           if(this.timer){
             clearInterval(this.timer)
           }
         })
       },
    },
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/forgetPassword.vue